import { createProviderWithCustomFetchData } from '../../common/providers/create-data-provider';
import { ExperienceMark } from '../../common/utils/experience-tracker';
export const fetchEmptyData = () => Promise.resolve({
  sites: undefined
});
export const createJoinableSitesProvider = (fetchData = fetchEmptyData, retryConfig) => {
  return createProviderWithCustomFetchData('joinableSites', ExperienceMark.API_JOINABLE_SITES, fetchData, retryConfig);
};